import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

const GoogleAnalyticsLoader = () => {
  const [gaId, setGaId] = useState(null);
  const location = useLocation();
  const [sessionId] = useState(() => {
    let sid = sessionStorage.getItem('analytics_session_id');
    if (!sid) {
      sid = Math.random().toString(36).substring(2) + Date.now().toString(36);
      sessionStorage.setItem('analytics_session_id', sid);
    }
    return sid;
  });

  useEffect(() => {
    // Fetch settings to get GA ID
    const fetchGaId = async () => {
      try {
        const res = await fetch(`${API}/api/settings/public`);
        if (res.ok) {
          const data = await res.json();
          if (data.google_analytics_id) {
            setGaId(data.google_analytics_id);
          }
        }
      } catch (e) {
        console.log('GA settings not available');
      }
    };
    fetchGaId();
  }, []);

  // Track pageviews in Google Analytics
  useEffect(() => {
    if (!gaId || !window.gtag) return;
    window.gtag('config', gaId, {
      page_path: location.pathname,
      page_title: document.title
    });
  }, [location, gaId]);

  // Track pageviews in our own database
  useEffect(() => {
    const trackPageView = async () => {
      try {
        await fetch(`${API}/api/analytics/pageview`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page_path: location.pathname,
            page_title: document.title,
            referrer: document.referrer || '',
            session_id: sessionId
          })
        });
      } catch (e) {
        // Silent fail - analytics should not block user experience
      }
    };
    trackPageView();
  }, [location, sessionId]);

  useEffect(() => {
    if (!gaId) return;

    // Check if GA is already loaded
    if (window.gtag) return;

    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId, {
      page_title: document.title,
      page_location: window.location.href
    });

    console.log('Google Analytics loaded:', gaId);
  }, [gaId]);

  return null;
};

export default GoogleAnalyticsLoader;
